import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { isSmartphoneOnly } from "./lib/deviceCheck";
import { TablePage } from "./routes/TablePage";
import { InvalidQrPage } from "./routes/InvalidQrPage";
import { UnsupportedDevicePage } from "./routes/UnsupportedDevicePage";

export const App = (): JSX.Element => {
  if (!isSmartphoneOnly()) return <UnsupportedDevicePage />;
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:restoId/:qrId" element={<TablePage />} />
        <Route path="/" element={<InvalidQrPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
};
